export function resolveRequestWorkspaceId(api, selectedWorkspaceId) {
  return api?.getWorkspaceIdSafe?.() || selectedWorkspaceId || null;
}
